/* eslint-disable import/no-anonymous-default-export */
import commonLoanProposalActionTypes from './common-loan-proposal.types';
import { docodeHexResponse } from '../../../_common/common.utils';

const INITIAL_STATE = {
	getLoanProposalResponse: null,
	getLoanProposalListArr: [],
	revertLoanIndexRep: null,
	getWholeGroupMemberResponse: null,
	getWholeGroupMemberArr: [],
	fetchParticularLoanIndexListResponse: null,
	fetchParticularLoanIndexListArr: [],
	getMemberLoanProductExistResponse: null,
	getMemberLoanProductExistListArr: [],
	approveLoanIndexResp: null,
	deleteLoanIndexResp: null,
	deleteMemberInLoanIndexResp: null,
	revertLoanProposalApproveDetailsResponse: null,
	addHFDCCreateIndividualLoanQRCodeArr: [],
	addHFDCCreateIndividualLoanQRCodeResp: null,
	getAppraisalLogResponse: null,
	getAppraisalLogListArr: [],
	moveToParticularAppraisalResponse: null,
	loanApproveOTPResponse: null,
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** GET LOAN PROPOSAL LIST START *********************** */
		case commonLoanProposalActionTypes.GET_LOAN_PROPOSAL_LIST_SUCCESS:
			return {
				...state,
				getLoanProposalResponse: action.payload,
				getLoanProposalListArr: docodeHexResponse(action.payload, 'getLoanIndexListKey'),
			};

		case commonLoanProposalActionTypes.GET_LOAN_PROPOSAL_LIST_FAILURE:
			return { ...state, getLoanProposalResponse: action.payload };

		case commonLoanProposalActionTypes.GET_LOAN_PROPOSAL_LIST_RESPONSE_CHANGED:
			return { ...state, getLoanProposalResponse: null };
		/** ***************** GET LOAN PROPOSAL LIST END *********************** */

		/** ***************** REVERT LOAN INDEX DETAILS START *********************** */
		case commonLoanProposalActionTypes.REVERT_LOAN_INDEX_SUCCESS:
			return {
				...state,
				revertLoanIndexRep: action.payload,
			};

		case commonLoanProposalActionTypes.REVERT_LOAN_INDEX_FAILURE:
			return {
				...state,
				revertLoanIndexRep: action.payload,
			};

		case commonLoanProposalActionTypes.REVERT_LOAN_INDEX_RESPONSE_CHANGED:
			return { ...state, revertLoanIndexRep: null };
		/** ***************** REVERT LOAN INDEX DETAILS END *********************** */

		/** ***************** REVERT LOAN INDEX DETAILS END *********************** */
		case commonLoanProposalActionTypes.GET_WHOLE_GROUP_MEMBER_LIST_SUCCESS:
			return {
				...state,
				getWholeGroupMemberResponse: action.payload,
				getWholeGroupMemberArr: docodeHexResponse(
					action.payload,
					'GetWholeGroupMemberKey',
				),
			};

		case commonLoanProposalActionTypes.GET_WHOLE_GROUP_MEMBER_LIST_FAILURE:
			return { ...state, getWholeGroupMemberResponse: action.payload };

		case commonLoanProposalActionTypes.GET_WHOLE_GROUP_MEMBER_LIST_RESPONSE_CHANGED:
			return { ...state, getWholeGroupMemberResponse: null };
		/** ***************** REVERT LOAN INDEX DETAILS END *********************** */

		/** ***************** FETCH PARTICULAR LOAN INDEX START *********************** */
		case commonLoanProposalActionTypes.FETCH_PARTICULAR_LOAN_INDEX_SUCCESS:
			return {
				...state,
				fetchParticularLoanIndexListResponse: action.payload,
				fetchParticularLoanIndexListArr: docodeHexResponse(
					action.payload,
					'FetchParticularLoanIndexKey',
				),
			};

		case commonLoanProposalActionTypes.FETCH_PARTICULAR_LOAN_INDEX_FAILURE:
			return { ...state, fetchParticularLoanIndexListResponse: action.payload };

		case commonLoanProposalActionTypes.FETCH_PARTICULAR_LOAN_INDEX_RESPONSE_CHANGED:
			return { ...state, fetchParticularLoanIndexListResponse: null };

		/** ***************** FETCH PARTICULAR LOAN INDEX END *********************** */

		/** ***************** FETCH HOLIDAY LIST START *********************** */

		case commonLoanProposalActionTypes.FETCH_HOLIDAY_LIST_SUCCESS:
			return {
				...state,
				getHolidayListResponse: action.payload,
				getHolidayListArr: docodeHexResponse(action.payload, 'GetHolidayDataKey'),
			};

		case commonLoanProposalActionTypes.FETCH_HOLIDAY_LIST_FAILURE:
			return { ...state, getHolidayListResponse: action.payload };

		case commonLoanProposalActionTypes.FETCH_HOLIDAY_LIST_RESPONSE_CHANGED:
			return { ...state, getHolidayListResponse: null };

		/** ***************** FETCH HOLIDAY LIST END *********************** */

		/** *****************  GET MEMBER LOAN PRODUCT EXIST START *********************** */
		case commonLoanProposalActionTypes.GET_MEMBER_LOAN_PRODUCT_EXIST_SUCCESS:
			return {
				...state,
				getMemberLoanProductExistResponse: action.payload,
				getMemberLoanProductExistListArr: docodeHexResponse(
					action.payload,
					'GetMemberLoanProductExistKey',
				),
			};

		case commonLoanProposalActionTypes.GET_MEMBER_LOAN_PRODUCT_EXIST_FAILURE:
			return { ...state, getMemberLoanProductExistResponse: action.payload };

		case commonLoanProposalActionTypes.GET_MEMBER_LOAN_PRODUCT_EXIST_RESPONSE_CHANGED:
			return { ...state, getMemberLoanProductExistResponse: null };

		/** *****************  GET MEMBER LOAN PRODUCT EXIST END *********************** */

		/** *****************  APPROVE LOAN INDEX DETAILS START *********************** */
		case commonLoanProposalActionTypes.APPROVE_LOAN_INDEX_SUCCESS:
			return {
				...state,
				approveLoanIndexResp: action.payload,
			};

		case commonLoanProposalActionTypes.APPROVE_LOAN_INDEX_FAILURE:
			return {
				...state,
				approveLoanIndexResp: action.payload,
			};

		case commonLoanProposalActionTypes.APPROVE_LOAN_INDEX_RESPONSE_CHANGED:
			return { ...state, approveLoanIndexResp: null };
		/** *****************  APPROVE LOAN INDEX DETAILS END *********************** */

		/** ***************** DELETE LOAN INDEX DETAILS START *********************/
		case commonLoanProposalActionTypes.DELETE_LOAN_INDEX_SUCCESS:
			return {
				...state,
				deleteLoanIndexResp: action.payload,
			};

		case commonLoanProposalActionTypes.DELETE_LOAN_INDEX_FAILURE:
			return {
				...state,
				deleteLoanIndexResp: action.payload,
			};

		case commonLoanProposalActionTypes.DELETE_LOAN_INDEX_RESPONSE_CHANGED:
			return { ...state, deleteLoanIndexResp: null };
		/** ***************** DELETE LOAN INDEX DETAILS END *********************/

		/** ***************** DELETE MEMBER IN LOAN INDEX DETAILS START *********************/
		case commonLoanProposalActionTypes.DELETE_MEMBER_IN_LOAN_INDEX_SUCCESS:
			return {
				...state,
				deleteMemberInLoanIndexResp: action.payload,
			};

		case commonLoanProposalActionTypes.DELETE_MEMBER_IN_LOAN_INDEX_FAILURE:
			return {
				...state,
				deleteMemberInLoanIndexResp: action.payload,
			};

		case commonLoanProposalActionTypes.DELETE_MEMBER_IN_LOAN_INDEX_RESPONSE_CHANGED:
			return { ...state, deleteMemberInLoanIndexResp: null };
		/** ***************** DELETE MEMBER IN LOAN INDEX DETAILS END *********************/

		/** ***************** REVERT LOAN PROPOSAL APPROVE DETAILS START *********************** */
		case commonLoanProposalActionTypes.REVERT_LOAN_PROPOSAL_APPROVE_DETAILS_SUCCESS:
			return { ...state, revertLoanProposalApproveDetailsResponse: action.payload };

		case commonLoanProposalActionTypes.REVERT_LOAN_PROPOSAL_APPROVE_DETAILS_FAILURE:
			return { ...state, revertLoanProposalApproveDetailsResponse: action.payload };

		case commonLoanProposalActionTypes.REVERT_LOAN_PROPOSAL_APPROVE_DETAILS_RESPONSE_CHANGED:
			return { ...state, revertLoanProposalApproveDetailsResponse: null };
		/** ***************** REVERT CUSTOM PRODUCT LOAN DETAILS END *********************** */

		/*********** HDFC CREATE INDIVIDUAL QRCODE START ************************ */
		case commonLoanProposalActionTypes.HDFC_CREATE_INDIVIDUAL_LOAN_QRCODE_SUCCESS:
			return {
				...state,
				addHFDCCreateIndividualLoanQRCodeResp: action.payload,
				addHFDCCreateIndividualLoanQRCodeArr: action.payload,
			};
		case commonLoanProposalActionTypes.HDFC_CREATE_INDIVIDUAL_LOAN_QRCODE_FAILURE:
			return { ...state, addHFDCCreateIndividualLoanQRCodeResp: action.payload };
		case commonLoanProposalActionTypes.HDFC_CREATE_INDIVIDUAL_LOAN_QRCODE_RESPONSE_CHANGED:
			return { ...state, addHFDCCreateIndividualLoanQRCodeResp: null };
		/*********** HDFC CREATE INDIVIDUAL QRCODE END ************************ */

		/*********** GET APPRAISAL LOG START ************************ */
		case commonLoanProposalActionTypes.GET_APPRAISAL_LOG_SUCCESS:
			return {
				...state,
				getAppraisalLogResponse: action.payload,
				getAppraisalLogListArr: docodeHexResponse(
					action.payload,
					'LoanAppraisalDetailsKey',
				),
			};
		case commonLoanProposalActionTypes.GET_APPRAISAL_LOG_FAILURE:
			return { ...state, getAppraisalLogResponse: action.payload };
		case commonLoanProposalActionTypes.GET_APPRAISAL_LOG_RESPONSE_CHANGED:
			return { ...state, getAppraisalLogResponse: null };
		/*********** GET APPRAISAL LOG END ************************ */

		/*********** MOVE TO PARTICULAR APPRAISAL START ************************ */
		case commonLoanProposalActionTypes.MOVE_TO_PARTICULAR_APPRAISAL_SUCCESS:
			return { ...state, moveToParticularAppraisalResponse: action.payload };

		case commonLoanProposalActionTypes.MOVE_TO_PARTICULAR_APPRAISAL_FAILURE:
			return { ...state, moveToParticularAppraisalResponse: action.payload };

		case commonLoanProposalActionTypes.MOVE_TO_PARTICULAR_APPRAISAL_RESPONSE_CHANGED:
			return { ...state, moveToParticularAppraisalResponse: null };
		/*********** MOVE TO PARTICULAR APPRAISAL END ************************ */

		/*********** LOAN APPROVE OTP START ************************ */
		case commonLoanProposalActionTypes.LOAN_APPROVE_OTP_SUCCESS:
			return { ...state, loanApproveOTPResponse: action.payload };

		case commonLoanProposalActionTypes.LOAN_APPROVE_OTP_FAILURE:
			return { ...state, loanApproveOTPResponse: action.payload };

		case commonLoanProposalActionTypes.LOAN_APPROVE_OTP_RESPONSE_CHANGED:
			return { ...state, loanApproveOTPResponse: null };
		/*********** LOAN APPROVE OTP END ************************ */

		default:
			return state;
	}
};
